<div class="lum-c-shipments-grid-actions">
  <button
    class="lum-button lum-button--secondary"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
  >
    Actions <i class="flaticon-more ml-2"></i>
  </button>
  <mat-menu class="lum-mat-menu" #menu="matMenu">
    <button mat-menu-item (click)="onOpenCreateShipmentDialog()"
      >Create Shipment</button
    >
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onRefreshGrid()">Refresh Table</button>
  </mat-menu>
</div>
